import { get, post } from './api';
import routes from './end-points';

export const adminDebtorsApi = {
  getAllDebtors: (data) => post(routes.adminDebtors.initDebtors, data),
};
